const buildTheContent = (theContent) => {
  try {
    if (!theContent) return;
    // Insert content title
    const titleEl = document.querySelector('[data-insertTitle]');
    if (titleEl) {
      titleEl.innerText = theContent.title;
    }

    // Process and insert content body
    const parsedContent = JSON.parse(theContent.cta_content);
    const contentBodyEl = document.querySelector('[data-insertContent]');

    // Helper to render text with bold/italic
    const renderText = (node) => {
      let text = node.value || '';
      if (node.bold) text = `<strong>${text}</strong>`;
      if (node.italic) text = `<em>${text}</em>`;
      return text;
    };

    // Helper to render children array
    const renderChildren = (children) => {
      return children
        .map((child) => {
          if (child.type === 'text') {
            return renderText(child);
          }
          if (child.type === 'link') {
            const url = child.url || '#';
            const title = child.title ? ` title="${child.title}"` : '';
            const target = child.target ? ` target="${child.target}"` : '';
            return `<a href="${url}"${title}${target}>${renderChildren(child.children || [])}</a>`;
          }
          if (child.type === 'heading') {
            const level = child.level || 1;
            return `<h${level}>${renderChildren(child.children || [])}</h${level}>`;
          }
          if (child.type === 'list') {
            const tag = child.listType === 'ordered' ? 'ol' : 'ul';
            return `<${tag}>${renderChildren(child.children || [])}</${tag}>`;
          }
          if (child.type === 'list-item') {
            return `<li>${renderChildren(child.children || [])}</li>`;
          }
          if (child.type === 'paragraph') {
            return `<p>${renderChildren(child.children || [])}</p>`;
          }
          return '';
        })
        .join('');
    };

    if (contentBodyEl && parsedContent.children && parsedContent.children.length > 0) {
      contentBodyEl.innerHTML = renderChildren(parsedContent.children);
    }

    // Insert content link
    const linkEl = document.querySelector('[data-insertLink]');
    if (linkEl) {
      if (theContent.cta_offer_link && theContent.cta_text) {
        linkEl.href = theContent.cta_offer_link;
        linkEl.querySelector('span').innerText = theContent.cta_text;
      } else {
        linkEl.remove();
      }
    }
  } catch (error) {
    console.error('Error building content:', error);
  }
};

const buildTheLocations = (dataLocations) => {
  try {
    if (!dataLocations || dataLocations.length === 0) return;
    // Template and container
    const LocationsCardTemplate = document.querySelector('#event_landing--location .location_card');
    if (!LocationsCardTemplate) return;

    const locationsContainer = document.querySelector('.event_landing--location_grid');
    const newLocationCards = [];

    dataLocations.forEach((el) => {
      const clone = LocationsCardTemplate.cloneNode(true);

      // Image
      const imageEl = clone.querySelector('[data-insert-image]');
      if (imageEl) {
        imageEl.src = el.image || 'https://via.placeholder.com/150';
        imageEl.alt = el.title || 'Location Image';
      }

      // Title
      const titleEl = clone.querySelector('[data-insert-store-title]');
      if (titleEl) {
        titleEl.innerText = el.title || 'Location Name';
        titleEl.removeAttribute('data-placeholder');
      }

      // Address
      const addressEl = clone.querySelector('[data-insert-store-address]');
      if (addressEl) {
        addressEl.innerText = el.address || 'Location Address';
        addressEl.removeAttribute('data-placeholder');
      }

      // Directions Link
      const directionsLinkEl = clone.querySelector('[data-insert-directions-link]');
      if (directionsLinkEl) {
        directionsLinkEl.href = el.getDirectionsUrl || '#';
        directionsLinkEl.removeAttribute('data-placeholder');
      }

      // Weekday Hours
      const weekdayHoursEl = clone.querySelector('[data-insert-store-weekday-hours]');
      if (weekdayHoursEl) {
        weekdayHoursEl.innerHTML = el.hours?.weekday || '';
        weekdayHoursEl.removeAttribute('data-placeholder');
      }

      // Weekend Hours
      const weekendHoursEl = clone.querySelector('[data-insert-store-weekend-hours]');
      if (weekendHoursEl) {
        weekendHoursEl.innerHTML = el.hours?.weekend || '';
        weekendHoursEl.removeAttribute('data-placeholder');
      }

      // Phone
      const phoneEl = clone.querySelector('[data-insert-store-phone]');
      if (phoneEl) {
        phoneEl.innerText = el.phone || '';
        phoneEl.href = el.phone ? `tel:${el.phone.replace(/[^0-9]/g, '')}` : '';
        phoneEl.removeAttribute('data-placeholder');
      }

      // Append to container
      newLocationCards.push(clone);
    });

    locationsContainer.innerHTML = '';
    newLocationCards.forEach((card) => {
      locationsContainer.appendChild(card);
    });
  } catch (error) {
    console.error('Error building locations:', error);
  }
};

const searchParams = window.location.search;
const theUrl = `/tools/my-kah-api/public/event${searchParams}`;
if (
  !!searchParams &&
  searchParams.includes('contentHandle=') &&
  (searchParams.includes('eventAddress=') ||
    searchParams.includes('eventZip=') ||
    searchParams.includes('storeHandle='))
) {
  fetch(theUrl)
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      const content = data.data.content;
      buildTheContent(content);

      const locations = data.data.locations;
      buildTheLocations(locations);

      document.querySelectorAll('[data-placeholder="true"]').forEach((el) => {
        el.removeAttribute('data-placeholder');
      });
    })
    .catch((err) => {
      console.log('error: ' + err);
    });
} else {
  document.querySelector('[id*="landing_dynamic_location"]').remove();
  document.querySelectorAll('[data-placeholder="true"]').forEach((el) => {
    el.removeAttribute('data-placeholder');
  });
}
